import { httpClient } from "../http/httpClient";

export type FormalizationUrlResponse = {
  url?: string;
  status: boolean;
};

export async function getFormalizationUrl({
  contract,
}: {
  contract: string;
}): Promise<FormalizationUrlResponse> {
  const { data } = await httpClient
    .get<FormalizationUrlResponse>(`/c6/formalization/${contract}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
